import API from '../api/index.ts';
import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';

class MemberItem extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	renderExpandedUI = memberObject => {
		let positionRaise = ''
		if(memberObject?.meta_data?.position_at_raise && memberObject?.meta_data?.position_at_raise !== ''){
			positionRaise = `<div>
										<p class="text-primary text-body-b4-regular md:text-body-b2-bold mb-1  tracking-normal">${ memberObject?.meta_data
				?.position_at_raise }</p>
									</div>`
		}
		let memberRoleInfo = `
									${
			(memberObject?.meta_data?.position ||
										 memberObject?.meta_data?.company) && (
											`<div class="mt-4">
										<p class="text-primary text-body-b2-bold">${ memberObject?.meta_data?.position }</p>
										<p class="text-secondary text-eyebrow-e1 mt-1 font-normal tracking-normal">${ memberObject?.meta_data?.company }</p>
									</div>` )
									}
									`;

		const apiObjectDecoded = window.apiObjectBE;
		let Linkedin = `${
			memberObject?.meta_data?.member_linkedin &&
			`
										<div class="mt-auto">
										<a href="${ memberObject?.meta_data?.member_linkedin }" target="_blank" class="w-10 h-10 flex items-center justify-center bg-white hover:bg-sand-95 transition-all duration-300 rounded-full overflow-hidden">
											<img class="w-5 h-5" alt="linkedin icon" src="${ apiObjectDecoded?.themeImageUrl }/linkedin.svg" />
										</a>
									</div>
										`
		}`
		Linkedin = `` // Disable render linkedin
		return `<div data-id="${ memberObject?.id }" class="raise-expanded-content flex w-full h-[400px]">
							<div class="w-full max-w-[400px] px-8 py-10 bg-neutral-98 flex-shrink-0 overflow-hidden relative before:absolute before:content-[''] before:-top-8 before:right-0 before:z-0 before:rounded-tl-[170.548px] before:rounded-bl-[170.548px] before:w-[306px] before:h-[264px] before:bg-sand-85 after:content-[''] after:absolute after:-bottom-10 after:left-0 after:z-0 after:rounded-tr-[170.548px] after:rounded-br-[170.548px] after:w-[306px] after:h-[264px] after:bg-sand-85">
								<div class="relative pt-2 z-10 flex flex-col h-full">
									${ positionRaise }
									<h5 class="text-primary text-headline-h6-medium md:text-headline-h5-medium font-adelle">${ memberObject?.title?.rendered }</h5>
									<div class="w-full h-[2px] bg-sand-70 my-4"></div>
									${ memberRoleInfo }
									${Linkedin}
								</div>

							</div>
							<div class="p-10 bg-sand-95 text-secondary text-body-b3-regular">
								<div class="w-full h-full overflow-y-auto pr-9 [&>*]:mb-4 lg:[&_blockquote]:text-body-qoute2 text-body-b2-regular">
								${ memberObject?.content?.rendered }
								</div>

							</div>
						</div>`;
	};

	getMemberExpandedInfo = async ( currentElement: HTMLElement ) => {
		try {
			const memberOverview = currentElement.querySelector( '.member-overview-content' ) as HTMLElement;
			const memberId = currentElement.dataset.id;
			const apiMethod = new API( { feature: 'posts/v1' } );
			const response = await apiMethod.getApi( `wp/v2/team_member/${ memberId }` );
			let expandedElementCloset = currentElement.nextElementSibling as HTMLElement;
			while (expandedElementCloset && !expandedElementCloset.classList.contains('raise-member-expanded')) {
				expandedElementCloset = expandedElementCloset.nextElementSibling;
			}

			if (!expandedElementCloset) return;

			const raiseExpandedContent = expandedElementCloset.querySelector('.raise-expanded-content');
			const isActive = document.querySelector('.raise-member-expanded.active');
			const ID_Getting = currentElement.getAttribute('data-id')
			if (!raiseExpandedContent && !isActive && window.currentActive != ID_Getting) {
				expandedElementCloset.classList.add('active');
				memberOverview.classList.add('active');
				expandedElementCloset.innerHTML = this.renderExpandedUI(response);
				window.currentActive = ID_Getting
			} else if(window.currentActive != ID_Getting) {
				isActive?.classList.remove('active')
				document.querySelector('.member-overview-content.active')?.classList.remove('active');
				expandedElementCloset.classList.add('active');
				memberOverview.classList.add('active');
				expandedElementCloset.innerHTML = this.renderExpandedUI(response);
				window.currentActive = ID_Getting
			}else{
				isActive?.classList.remove('active')
				expandedElementCloset.classList.remove('active');
				memberOverview.classList.remove('active');
				window.currentActive = ''
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	init() {
		let getCurrentHeight = this.selector.style.height
		this.selector.addEventListener( 'click', ( e: MouseEvent ) => {
			if ( window.matchMedia( '(min-width: 600px)' ).matches ) {
				this.getMemberExpandedInfo( this.selector );
			} else {
				console.log('clicked')
				const target = e.target as HTMLElement;
				const isLink = target?.tagName === 'A' || target?.closest( 'a' );
				if(!this.selector.classList.contains('active')){
					this.selector.style.height = null
				}else{
					this.selector.style.height = `${getCurrentHeight}px`
				}
				if ( !isLink ) {
					this.selector.classList.toggle( 'active' );
				}
			}
		} );
		const showMoreBtn = this.selector.querySelector( '.js-show-more-btn' ) as HTMLElement;
		if ( showMoreBtn ) {
			showMoreBtn.addEventListener( 'click', () => {
				const memberDescription = this.selector.querySelector( '.js-member-description' ) as HTMLElement;
				const dropdownIcon = showMoreBtn.querySelector( '.icon-dropdown' ) as HTMLElement;
				const showLabel = showMoreBtn.querySelector('.show') as HTMLElement
				const lessLabel = showMoreBtn.querySelector('.less') as HTMLElement
				if ( memberDescription.classList.contains( 'line-clamp-[10]' ) ) {
					memberDescription.classList.remove( 'line-clamp-[10]' );
					dropdownIcon.classList.add( 'active' );
				} else {
					memberDescription.classList.add( 'line-clamp-[10]' );
					dropdownIcon.classList.remove( 'active' );
				}
				showLabel.classList.toggle('hidden')
				lessLabel.classList.toggle('hidden')
			} );
		}
	}
}

export default MemberItem;
